import Media from '@travel/traveler-core/components/Media';
import { isEmptyArray } from '@travel/utils';
import type { MediaItem } from 'ProviderPlan-Types';
import NoImageContent from './NoImageContent';

type Props = {
  mediaArray: MediaItem[];
  mediaClassName?: string;
  mediaWrapperClassName?: string;
};

const CustomMedium = (props: Props) => {
  const { mediaArray, mediaClassName, mediaWrapperClassName } = props;
  return (
    <>
      {isEmptyArray(mediaArray) ? (
        <NoImageContent mediaWrapperClassName={mediaWrapperClassName} />
      ) : (
        mediaArray.map((mediaObj, index) => (
          <Media
            media={mediaObj}
            key={index}
            className={mediaClassName}
            wrapperClassName={mediaWrapperClassName}
          />
        ))
      )}
    </>
  );
};

export default CustomMedium;
